import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { SnippetsOutlined } from '@vicons/antd';
import { PricetagOutline, LibraryOutline } from '@vicons/ionicons5';
import { ComputerFilled } from '@vicons/material';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/library',
    name: 'library',
    redirect: '/library/item',
    component: Layout,
    meta: {
      title: 'Library',
      icon: renderIcon(LibraryOutline),
      permissions: [
        'library_item_read',
        'library_specification_read',
        'library_imit-specification_read',
      ],
      sort: 1.5,
    },
    children: [
      {
        path: 'item',
        name: 'library_item',
        meta: {
          title: 'Item',
          prefix: 'Library',
          icon: renderIcon(PricetagOutline),
          permissions: ['library_item_read'],
        },
        component: () => import('@/views/library/item/index.vue'),
      },
      {
        path: 'specification',
        name: 'library_specification',
        meta: {
          title: 'Specification',
          prefix: 'Library',
          spname: 'library_specification',
          icon: renderIcon(SnippetsOutlined),
          permissions: ['library_specification_read'],
        },
        component: () => import('@/views/library/specification/index.vue'),
      },
      {
        path: 'imit-specification',
        name: 'library_imit-specification',
        meta: {
          title: 'IMIT Specification',
          prefix: 'Library',
          icon: renderIcon(ComputerFilled),
          permissions: ['library_imit-specification_read'],
        },
        component: () => import('@/views/library/imit-specification/index.vue'),
      },
    ],
  },
];

export default routes;
